module.exports = "/v2/pages/dashboard/dist/7c8eef826a88c75e7fe2c71cdc4f4252.svg";